import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { get, postJson } from "../helpers/network";
import { PhoneIcon } from "@heroicons/react/24/outline";
import { getScritId } from "../helpers/globals";
import SwipeUpModal from "./SwipeUpModal";
import MessageLead from "./MessageLead";
import callBackIcon from "../images/callback.svg";
import Callback from "./Callback";

export default function Header({ user }) {
  const [onlineStatus, setOnlineStatus] = useState(
    user.status ? "Online" : "Offline"
  );
  const [messageData, setMessageData] = useState({
    isOpen: false,
    setScriptId: "",
  });
  const [callBackData, setCallBackData] = useState({
    isOpen: false,
    setScriptId: "",
  });
  const [teamMembers, setTeamMembers] = useState([]);

  const onStatusChange = (e) => {
    var status = e.target.checked ? "1" : "0";
    setOnlineStatus(e.target.checked ? "Online" : "Offline");

    postJson(`team/update-member-availability/${user.id}/${status}`);
  };

  const getScriptIdData = async () => {
    const abc = await getScritId();
    setMessageData({
      isOpen: true,
      setScriptId: abc,
    });
  };

  const manageCallback = () => {
    setCallBackData({
      ...callBackData,
      isOpen: true,
    });
  };

  const getTeamMembers = async () => {
    var members = await get("team/members");
    members = await members.json();
    setTeamMembers(members.data.members);
  };

  useEffect(() => {
    getTeamMembers();
  }, []);

  return (
    <>
      <div className="home-top">
        <div className="logo">
          <Link to="/">
            <img src="../images/logo-limecall.svg" alt="Logo LimeCall" />
          </Link>
        </div>

        <div className="actions">
          <div className="availability">
            <div className="custom-control custom-switch">
              <input
                checked={onlineStatus == "Online" ? true : false}
                onChange={onStatusChange}
                type="checkbox"
                className="custom-control-input"
                id="customSwitch1"
              />
              <label
                className="custom-control-label"
                htmlFor="customSwitch1"
              ></label>
            </div>
            <div id="show-onoff-status">
              {onlineStatus == "Online" ? (
                <span className="text-green-500">Online</span>
              ) : (
                <span className="text-red-500">Offline</span>
              )}
            </div>
          </div>
          {/* <div className="notifications">
            <Link id="goto-home" to="/dialer">
              <PhoneIcon
                width="20"
                height="20"
                viewBox="0 0 18 20"
                className="icon-overflow"
                color="#a4abc4"
              />
            </Link>
          </div> */}
          <div className="nav-message">
            <span onClick={getScriptIdData}>
              <svg
                title="Message"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 26"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6 cursor-pointer text-white mr-0"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a5.969 5.969 0 01-.474-.065 4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z"
                ></path>
              </svg>
            </span>
          </div>
          <div className="call-back">
            <span onClick={manageCallback}>
              <img
                title="CallBack"
                className="image-size"
                src={callBackIcon}
                alt="callback"
              />
            </span>
          </div>
          <div className="notifications">
            <Link id="goto-notifications" to="/notifications">
              <svg
                width="18"
                height="20"
                viewBox="0 0 18 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.63856 0.00871651C4.59682 0.199086 1.49988 3.67162 1.49988 7.69036V11.3241L0.174688 13.9902C0.172357 13.995 0.170078 13.9999 0.167852 14.0048C-0.365276 15.1386 0.497737 16.4999 1.75086 16.4999H5.99988C5.99988 18.1479 7.35195 19.4999 8.99988 19.4999C10.6478 19.4999 11.9999 18.1479 11.9999 16.4999H16.2479C17.5011 16.4999 18.3652 15.1388 17.8319 14.0048C17.8297 13.9999 17.8274 13.995 17.8251 13.9902L16.4999 11.3241V7.49993C16.4999 3.24683 12.9315 -0.19339 8.63856 0.00871651ZM8.70887 1.50676C12.1689 1.34387 14.9999 4.08103 14.9999 7.49993V11.4999C14.9998 11.6158 15.0265 11.7301 15.078 11.8339L16.4745 14.6445C16.5643 14.8369 16.4604 14.9999 16.2479 14.9999H1.75086C1.5384 14.9999 1.43534 14.8372 1.52527 14.6445V14.6435L2.92176 11.8339C2.97325 11.7301 2.99999 11.6158 2.99988 11.4999V7.69036C2.99988 4.44009 5.48961 1.65839 8.70887 1.50676ZM7.49988 16.4999H10.4999C10.4999 17.337 9.83695 17.9999 8.99988 17.9999C8.16282 17.9999 7.49988 17.337 7.49988 16.4999Z"
                  fill="#A4ABC5"
                />
              </svg>
              {user.unread_notification > 0 && (
                <span id="unread_notifications_count" className="badge">
                  {user.unread_notification}
                </span>
              )}
            </Link>
          </div>
          <div className="settings">
            <Link id="goto-settings" to="/settings">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.99995 0C9.2115 0 8.45128 0.0997142 7.72554 0.268555C7.5742 0.303878 7.43757 0.385336 7.33453 0.501671C7.23149 0.618005 7.16713 0.763473 7.15034 0.917969L6.99116 2.36914C6.9391 2.84468 6.66441 3.26543 6.24995 3.50488C5.83632 3.74386 5.33426 3.77033 4.89644 3.57812H4.89546L3.56245 2.99121C3.42027 2.92864 3.26217 2.91176 3.10998 2.9429C2.95779 2.97403 2.81902 3.05165 2.71284 3.16504C1.67659 4.26979 0.881292 5.60753 0.429639 7.10059C0.38465 7.24919 0.386885 7.40809 0.436037 7.55537C0.485189 7.70265 0.578834 7.83105 0.704053 7.92285L1.88667 8.79004C2.27285 9.07396 2.49995 9.5214 2.49995 10C2.49995 10.4789 2.27285 10.9267 1.88667 11.21L0.704053 12.0762C0.578834 12.168 0.485189 12.2964 0.436037 12.4437C0.386885 12.5909 0.38465 12.7498 0.429639 12.8984C0.881244 14.3913 1.67591 15.7301 2.71284 16.835C2.81914 16.9482 2.95796 17.0256 3.11014 17.0566C3.26232 17.0875 3.42037 17.0705 3.56245 17.0078L4.89546 16.4209C5.3335 16.2283 5.83604 16.256 6.24995 16.4951C6.66441 16.7346 6.9391 17.1553 6.99116 17.6309L7.15034 19.082C7.16726 19.2362 7.23156 19.3814 7.3344 19.4975C7.43724 19.6136 7.57355 19.695 7.72456 19.7305C8.45064 19.8999 9.2115 20 9.99995 20C10.7884 20 11.5486 19.9003 12.2744 19.7314C12.4257 19.6961 12.5623 19.6147 12.6654 19.4983C12.7684 19.382 12.8328 19.2365 12.8496 19.082L13.0087 17.6309C13.0608 17.1553 13.3355 16.7346 13.75 16.4951C14.1636 16.2561 14.6656 16.2287 15.1035 16.4209L16.4375 17.0078C16.5795 17.0705 16.7376 17.0875 16.8898 17.0566C17.0419 17.0256 17.1808 16.9482 17.2871 16.835C18.3233 15.7302 19.1186 14.3915 19.5703 12.8984C19.6153 12.7498 19.613 12.5909 19.5639 12.4437C19.5147 12.2964 19.4211 12.168 19.2959 12.0762L18.1132 11.21C17.7271 10.9267 17.5 10.4789 17.5 10C17.5 9.52114 17.7271 9.07333 18.1132 8.79004L19.2959 7.92383C19.4211 7.83203 19.5147 7.70363 19.5639 7.55635C19.613 7.40907 19.6153 7.25017 19.5703 7.10156C19.1186 5.60851 18.3233 4.26979 17.2871 3.16504C17.1808 3.05182 17.0419 2.97438 16.8898 2.94342C16.7376 2.91246 16.5795 2.9295 16.4375 2.99219L15.1035 3.5791C14.6656 3.77131 14.1636 3.74386 13.75 3.50488C13.3355 3.26543 13.0608 2.84468 13.0087 2.36914L12.8496 0.917969C12.8326 0.763777 12.7683 0.618621 12.6655 0.502492C12.5627 0.386363 12.4264 0.304974 12.2753 0.269531C11.5493 0.100078 10.7884 0 9.99995 0ZM9.99995 1.5C10.4871 1.5 10.9549 1.58744 11.4238 1.66992L11.5175 2.53223C11.6215 3.48169 12.1734 4.32617 13 4.80371C13.827 5.28157 14.834 5.3365 15.708 4.95215L16.5009 4.60352C17.1098 5.3347 17.5919 6.16059 17.9287 7.06543L17.2255 7.58105C16.4557 8.14576 16 9.04486 16 10C16 10.9551 16.4557 11.8542 17.2255 12.4189L17.9287 12.9346C17.5919 13.8394 17.1098 14.6653 16.5009 15.3965L15.708 15.0479C14.834 14.6635 13.827 14.7184 13 15.1963C12.1734 15.6738 11.6215 16.5183 11.5175 17.4678L11.4238 18.3301C10.955 18.4123 10.4869 18.5 9.99995 18.5C9.5128 18.5 9.04499 18.4126 8.57612 18.3301L8.48237 17.4678C8.37843 16.5183 7.82649 15.6738 6.99995 15.1963C6.17287 14.7184 5.1659 14.6635 4.29194 15.0479L3.49897 15.3965C2.88994 14.6654 2.40792 13.8395 2.07124 12.9346L2.77437 12.4189C3.54418 11.8542 3.99995 10.9551 3.99995 10C3.99995 9.04486 3.54381 8.14518 2.77437 7.58008L2.07124 7.06445C2.40812 6.15927 2.89068 5.33392 3.49995 4.60254L4.29194 4.95117C5.1659 5.33553 6.17287 5.28157 6.99995 4.80371C7.82649 4.32617 8.37843 3.48169 8.48237 2.53223L8.57612 1.66992C9.04495 1.58767 9.51304 1.5 9.99995 1.5ZM9.99995 6C7.7997 6 5.99995 7.79975 5.99995 10C5.99995 12.2003 7.7997 14 9.99995 14C12.2002 14 14 12.2003 14 10C14 7.79975 12.2002 6 9.99995 6ZM9.99995 7.5C11.3895 7.5 12.5 8.6104 12.5 10C12.5 11.3896 11.3895 12.5 9.99995 12.5C8.61035 12.5 7.49995 11.3896 7.49995 10C7.49995 8.6104 8.61035 7.5 9.99995 7.5Z"
                  fill="#A4ABC4"
                />
              </svg>
            </Link>
          </div>
        </div>
        {messageData?.isOpen && (
          <SwipeUpModal
            component={<MessageLead scriptId={messageData.isOpen} />}
            onClosed={() => {
              setMessageData({
                ...messageData,
                isOpen: false,
                setScriptId: "",
              });
            }}
          />
        )}
        {callBackData.isOpen && (
          <SwipeUpModal
            component={
              <Callback teamMembers={teamMembers} lead={{ phone_number: "" }} />
            }
            // component={swipeUpComponent()}
            onClosed={() => {
              setCallBackData({
                ...callBackData,
                isOpen: false,
              });
            }}
          />
        )}
      </div>
    </>
  );
}
